import TerminoProjetos from './componentes/TerminoProjetos.vue';
import TerminoProjetoLista from './componentes/TerminoProjetoLista.vue';

export default {
  path: '/termino-projetos',
  component: TerminoProjetos,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: TerminoProjetoLista,
      name: 'termino-projetos',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/projetos-termino/rotas.js